// A bordered, rounded box for one thing in a list of things (a connection, a
// destination, a request) or a side column. `title` and `actions` make its
// header row; anything else is its body. `flush` drops the padding, for a
// list whose rows run to the edges.
export default function Panel({ as: Tag = "div", title = null, meta = null, actions = null, flush = false, className = "", children, ...attrs }) {
    return (
        <Tag className={`grid min-w-0 rounded-[10px] border border-[color:var(--line)] bg-[color:var(--panel)] ${flush ? "overflow-hidden" : "gap-[12px] p-[16px]"} ${className}`} {...attrs}>
            {title || actions ? (
                <div className="flex flex-wrap items-start justify-between gap-x-[14px] gap-y-[8px]">
                    <div className="grid min-w-0 gap-[3px]">
                        {title ? <h3 className="m-0 text-[14px] font-medium leading-[1.35] text-[color:var(--ink)] [overflow-wrap:anywhere]">{title}</h3> : null}
                        {meta ? <div className="text-[12.5px] leading-[1.4] text-[color:var(--muted)]">{meta}</div> : null}
                    </div>
                    {actions ? <div className="flex flex-wrap items-center gap-[6px]">{actions}</div> : null}
                </div>
            ) : null}
            {children}
        </Tag>
    );
}
